import { render } from "./UploadImage.vue?vue&type=template&id=260eee0e&ts=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__